import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class Holiday extends ModelBase {
    static typeName = "Holiday";

    public holidayId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public holidayDate: Date | null = null;

    @Rules.StringLength(50)
    @Rules.Required()
    @Attributes.Display("Holiday")
    public holidayName: string = "";

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.holidayName) {
            return "New holiday";
        } else {
            return this.holidayName;
        }
    }
}